<template>
  <div style="padding-bottom: 5px">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>Home</el-breadcrumb-item>
      <el-breadcrumb-item>Administrator</el-breadcrumb-item>
      <el-breadcrumb-item>Test T&C</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <el-card>
    <template #header>
      <div>Test T&C</div>
    </template>
    <el-row>
      <el-col :span="24"><div>Payload</div></el-col>
      <el-col>
        <el-input type="textarea" :rows="6" v-model="payload"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"> <el-button @click="Test">Test</el-button></el-col>
    </el-row>
    <el-row v-if="results.length > 0">
      <el-col :span="24"><div>Result</div></el-col>
      <el-col>
        <div
          v-for="(item, index) in results"
          :key="'result_' + index"
          style="display: flex; width: 60%"
        >
          <div style="min-width: 30px; width: 30px">
            {{ !item.is_two_serial ? item.one_serial : '' }}
          </div>
          <div style="min-width: 30px; width: 30px" v-if="item.is_two_serial">
            {{ item.one_serial }}
          </div>
          <div style="min-width: 500px">{{ item.content }}</div>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { request } from '@/network/request';
const payload = ref('{}');

const results = ref([]);

const Test = () => {
  var data = JSON.parse(payload.value);

  request({
    url: '/admin/testTandC',
    method: 'post',
    data,
  }).then((res) => {
    if (res.data) {
      results.value = res.data;
    }
  });
};
</script>
<style scoped></style>
